/**
 * The vendor notice shown beside [Record] every time, before the microphone opens (ADR-002 §21.2, invariant I6).
 * Audio goes to the browser's own speech service while the member records; Amplispot receives text only.
 *
 * The same words as the Meetings recorder (design meetings-v2 frame 03, `.vnotice`). Capture and Meetings (LogMeeting.tsx)
 * both import it from here, so the two recorders can never drift apart.
 */
export const VENDOR_NOTICE =
  'Your browser’s speech service turns your voice into text: Google in Chrome, Microsoft in Edge, Apple in Safari. Audio is sent to them while you record. Amplispot does not receive or keep it.';
